import { IconType } from 'react-icons';
import { Project } from '../types';
import { FaPills, FaFilm } from 'react-icons/fa';
import {
  SiFlutter,
  SiDart,
  SiSqlite,
  SiMaterialdesign,
  SiGo,
  SiPostgresql,
  SiReact,
  SiTypescript,
  SiVite,
  SiZod,
  SiDocker
} from 'react-icons/si';

export const projects: Project[] = [
  {
    id: 'mediminder',
    title: 'MediMinder',
    description: 'Medication reminder app built for elderly users — scheduled alarms, adherence tracking, and refill alerts.',
    problem: 'Elderly users miss doses or forget whether they took their medication, and caregivers have no visibility.',
    features: [
      'Daily scheduling with customisable times and frequencies',
      'Reliable alarms that bypass Do Not Disturb via the OS alarm channel',
      'Adherence tracking with a weekly history view',
      'Refill alerts based on remaining doses',
      'Accessibility-first: large touch targets and type, WCAG AA minimum'
    ],
    technologies: ['Flutter', 'Dart', 'Riverpod', 'SQLite', 'Drift', 'GoRouter', 'Material Design 3'],
    status: 'coming-soon',
    icon: FaPills
  },
  {
    id: 'watchlist',
    title: 'Watchlist',
    description: 'Full-stack personal movie tracker — add, rate, review, and filter movies across want-to-watch and watched lists.',
    problem: 'No simple personal tool to track, rate, and annotate movies without ads or social noise.',
    features: [
      'Add, edit, and delete movies with title, year, genre, and description',
      'Mark as watched, rate 1–5 stars, and add personal notes',
      'Real-time search and filtering by status, rating, and date added',
      'JWT + Google OAuth authentication',
      'Docker Compose local dev, deployable to Fly.io or Railway'
    ],
    technologies: ['Go', 'chi', 'PostgreSQL', 'React', 'TypeScript', 'Vite', 'Zod', 'Docker'],
    status: 'in-progress',
    icon: FaFilm
  }
];

// Brand icons for recognised technologies; chips without an entry render text-only
export const techIcons: Record<string, IconType> = {
  Flutter: SiFlutter,
  Dart: SiDart,
  SQLite: SiSqlite,
  'Material Design 3': SiMaterialdesign,
  Go: SiGo,
  PostgreSQL: SiPostgresql,
  React: SiReact,
  TypeScript: SiTypescript,
  Vite: SiVite,
  Zod: SiZod,
  Docker: SiDocker
};

export const statusLabels: Record<Project['status'], string> = {
  'completed': 'Released',
  'in-progress': 'In Progress',
  'coming-soon': 'Coming Soon'
};
